import Container from "@components/UI/Container";
import Section, { SectionHeadline } from "@components/Section";
import { twJoin } from "tailwind-merge";
import { PaymentPlan } from "../paymentPlansData";
import { FeaturesTableDesktop } from "./FeaturesTableDesktop";
import { FeaturesTableMobile } from "./FeaturesTableMobile";

export type FeaturesTableProps = {
  paymentPlan?: PaymentPlan
}

export function FeaturesTable({ paymentPlan }: FeaturesTableProps) {
  if (!paymentPlan) {
    return
  }

  return (
    <div id="features-table" className="scroll-mt-[20px]">
      <Section
        className={"bg-slate-blue-100"}
        mods={{
          overflow: 'visible',
          py: true,
          'no-margin': true
        }}
      >
        <Container className="1280:(px-0)">
          <SectionHeadline
            mods={{ center: true, w: 75 }}
            className={'relative lg:w-[75%]'}
          >
            <h2 className={twJoin("text-26p", "1024:text-44p", "font-600 text-neutral2-900")}>
              Compare plans
            </h2>
          </SectionHeadline>
          <FeaturesTableMobile className="xl:hidden" paymentPlan={paymentPlan} />
          <FeaturesTableDesktop className="hidden xl:flex" paymentPlan={paymentPlan} />
        </Container>
      </Section>
    </div>
  );
}
